import React from 'react';
import { SelectProps } from 'antd/lib/select';
import Select from 'src/components/common/Select';

export type DropdownOption = {
  value: number;
  label: string;
};

type DropdownProps<T extends DropdownOption> = {
  value: T['value'];
  options: T[];
  className?: string;
  disabled?: boolean;
  showOptionIfExists?: boolean;
  onChange: (value: T['value']) => void;
};

const ScriptActivationDropdown = <T extends DropdownOption>({
  value,
  options,
  className,
  disabled,
  showOptionIfExists = true,
  onChange,
}: DropdownProps<T>) => {
  const optionExists = options.some((opt) => opt.value === value);
  const selectedValue = optionExists ? value : undefined;
  return (
    <Select
      value={showOptionIfExists ? selectedValue : value}
      className={className}
      disabled={disabled}
      showArrow={true}
      onChange={onChange as SelectProps['onChange']}
    >
      {options.map(({ value, label }, i) => (
        <Select.Option value={value} key={`${value}:${i}`}>
          {label}
        </Select.Option>
      ))}
    </Select>
  );
};

export default ScriptActivationDropdown;
